<template lang="pug">
  #app-layout
    component(:is="(this.$route.meta.layout || 'Default') + 'Layout'")
      RouterView(:key="$route.fullPath")
</template>

<script>
export default {
  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  mounted() {
    this.$breakpoint.build()
  },

  methods: {},

  components: {},
}

/* Computed ---------------------------------------------------- */
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
</script>
